import { animate } from 'motion/react'
import ease from '@/utils/ease'

export default () => ({
	contentHeight: 0,
	$wrapper: null,
	$content: null,
	$trigger: null,
	$icon: null,

	init() {
		// Store DOM references
		this.$trigger = this.$el.querySelector('[data-accordion-trigger]')
		this.$wrapper = this.$el.querySelector('[data-accordion-wrapper]')
		this.$content = this.$el.querySelector('[data-accordion-content]')
		this.$icon = this.$el.querySelector('[data-accordion-icon]')

		// Verify elements are found
		if (!this.$wrapper || !this.$icon) {
			console.warn('Required accordion elements not found')
			return
		}

		// Set up event listeners
		this.$trigger?.addEventListener('click', () => this.toggleAccordion())
		window.addEventListener('resize', () => this.measureHeight())

		// Initial height measurement
		this.measureHeight()

		// Watch for changes in parent's currentOpenAccordion
		this.$watch('$parent.currentOpenAccordion', () => this.updateAccordionState())
	},

	get isExpanded() {
		return this.$parent.currentOpenAccordion === this.index
	},

	updateAccordionState() {
		const isExpanded = this.isExpanded

		// Run animations
		animate(
			this.$wrapper,
			{ height: `${isExpanded ? this.contentHeight : 0}px` },
			{ duration: 0.35, easing: ease.inOutQuint },
		)
		animate(
			this.$icon,
			{ rotate: isExpanded ? -45 : 0 },
			{ duration: 0.35, easing: ease.inOutQuint },
		)
	},

	measureHeight() {
		if (!this.$content) return

		setTimeout(() => {
			const height = this.$el
				.querySelector('[data-accordion-content]')
				.getBoundingClientRect().height
			this.contentHeight = height
		}, 0)
	},

	toggleAccordion() {
		this.$parent.openAccordion(this.index)
	},
})
